export default __webpack_public_path__ + "static/anim_preload-488f3114e51dc61ecdc156517ba68349.webp";